<!-- 拒绝弹窗 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    @close="$emit('input', false)"
    :width="width"
    top="50px"
  >
    <div class="tip-box">
      <i class="el-icon-info" style="margin-right: 10px;font-size: 20px;"></i>
      <p>
        建议先和买家协商处理,达成一致后,买家可修改售后或取消后重新申请。如您拒绝,买家可以要求平台介入处理,如果平台核实是你的责任,会产生相应影响。
        <!-- <span @click="seeDetail" class="detail-link">详情</span> -->
      </p>
    </div>
    <el-form ref="formData" :model="formData" label-width="80px">
      <el-form-item label="拒绝原因">
        <el-select v-model="formData.reject_reason_type" placeholder="请选择拒绝原因" style="width: 400px;">
          <el-option v-for="(item, index) in rejectReasonList" :key="index" :label="item.reject_reason_type_text" :value="item.reject_reason_type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="补充说明">
        <el-input type="textarea" rows="5" v-model="formData.reject_reason"></el-input>
      </el-form-item>
      <!-- <el-form-item label="证据截图">
        <upload-img style="margin-left: 13px;" @changeImgs="changeImgs"></upload-img>
      </el-form-item> -->
      <el-divider></el-divider>
      <el-form-item label="售后商品">
        <div class="product-detail">
          <el-image class="product-pic" :src="detailObj.product_img" fit="fit"></el-image>
          <div class="info">
            <div class="info-name">{{ detailObj.product_title }}</div>
            <div class="info-num">{{ detailObj.scount }}件</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="售后概述">
        <div class="intro-box">
          <div class="intro-item">
            <div class="title">类型原因：</div>
            <div class="content">
              {{ detailObj.reason_text }}
            </div>
          </div>
          <div class="intro-item">
            <div class="title">退款金额：</div>
            <div class="content">
              ¥{{ detailObj.refund_amount }}
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button type="primary" @click="sureFn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import uploadImg from './uploadImg.vue'
import { mapActions } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "提示",
    },
    width: {
      type: String,
      default: "40%",
    },
    detailObj: { // 详情
      type: Object,
      default: ()=> {
        return {}
      }
    },
  },
  components: {
    'upload-img': uploadImg,
  },
  watch: {
    value(nval) {
      this.show = nval;
      this.formData = {
        reject_reason_type: '',
        reject_reason: ''
      }
    },
  },
  data() {
    return {
      show: false,
      formData: {
        reject_reason_type: '',
        reject_reason: ''
      }, 
      rejectReasonList: [] // 拒绝退款原因
    };
  },
  created(){
    this.getRejectReasonList()
  },
  methods: {
    ...mapActions('sphApis',['rejectRefundAPI', 'getRejectReasonListAPI']),
    // 获取拒绝退款原因
    async getRejectReasonList(){
      let res = await this.getRejectReasonListAPI()
      this.rejectReasonList = res
    },
    // 提交表单
    async sureFn() {
      await this.rejectRefundAPI({
        ...this.formData,
        after_sale_order_id: this.detailObj.after_sale_order_id
      })
      this.$emit('sureReject')
      this.show = false
    },
    // 点击详情
    seeDetail(){
      window.open('https://www.baidu.com')
    },
    changeImgs(e){
      this.formData.imgs = e
    }
  },
};
</script>

<style lang="less" scoped>
.tip-box{
  display: flex;
  align-items: center;
  background: #f6f6f6;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 20px;
  .detail-link{
    color: #1989FA;
    cursor: pointer;
  }
}
.product-detail{
  display: flex;
  .product-pic{
    border-radius: 6px;
    width: 110px;
    height: 82px;
  }
  .info{
    margin-left: 10px;
    .info-name{
      font-weight: 700;
    }
    .info-num{
      color: #b6b6b6;
    }
  }
}
.intro-box{
  .intro-item{
    display: flex;
  }
}
</style>
